// src/utils/novita.js
// ═══════════════════════════════════════════════════════════════════════════
// COSA C'È DI NUOVO (ottobre 2026)
// ═══════════════════════════════════════════════════════════════════════════
// Dopo un aggiornamento, una scheda breve (components/NovitaNexiora.js) mostra UNA volta per
// dispositivo le novità che si usano davvero, con il collegamento alla pagina giusta.
// Per una nuova consegna: aggiungere IN CIMA un blocco con un id nuovo (la data) e solo
// funzioni realmente presenti. Chi ha creato l'account dopo quella data non la vede (per lui
// non sono novità). Le voci restano brevi: una riga e mezza al massimo.
// ═══════════════════════════════════════════════════════════════════════════

export const NOVITA = [
  {
    id: "2026-10-31-un-solo-calcolo",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "🧮", testo: "Un solo calcolo economico: Controllo Economico, report, Relazione finale e Cabina di Regia danno gli stessi costi e lo stesso margine." },
      { icona: "🕒", testo: "Report e Relazione calcolano manodopera e noleggi al momento; Insight e Centro Operativo dicono a quando sono aggiornati." },
    ],
  },
  {
    id: "2026-10-31-numeri-coerenti",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "📄", testo: "Report periodico: i costi del periodo comprendono manodopera e ordini di acquisto, elencati riga per riga fino al totale." },
      { icona: "⏰", testo: "Attività in ritardo contate allo stesso modo ovunque: annullate e sospese non lo sono mai." },
    ],
  },
  {
    id: "2026-10-31-report-periodico",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "📄", testo: "Report periodico più preciso: il valore della commessa comprende le varianti accettate, come nel Controllo economico." },
      { icona: "✅", testo: "Nel report le attività compaiono con nome, responsabile e data reale di completamento; le scadute con la loro scadenza." },
    ],
  },
  {
    id: "2026-10-31-permessi",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "🔒", testo: "Più sicurezza dentro l'azienda: Abilitazioni e approvazioni (cartellini, note spese, ferie) sono controllate anche dal database; nessuno approva le proprie." },
      { icona: "💬", testo: "Le chat le leggono solo i partecipanti; il registro modifiche non si può più cambiare né cancellare." },
    ],
  },
  {
    id: "2026-10-30-password",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "🔑", testo: "Password dimenticata? Arriva un'email Nexiora con il pulsante «Reimposta password»: scegli la nuova password e la confermi, su una pagina Nexiora." },
      { icona: "🛡️", testo: "Password più sicure: almeno 8 caratteri, e per cambiarla da Impostazioni → Profilo serve quella attuale." },
    ],
  },
  {
    id: "2026-10-30-registrazione",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "🙋", testo: "Se qualcuno prova a registrare la vostra Partita IVA, può chiedervi l'accesso: vi arriva una notifica con nome ed email, e decidete voi se invitarlo da Gestione Utenti." },
    ],
  },
  {
    id: "2026-10-30-accessi",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "✉️", testo: "Inviti più semplici: scegli il ruolo, il collega apre il link nell'email, sceglie la password ed entra subito. Niente più codici dell'azienda." },
      { icona: "🔐", testo: "Chi è disabilitato perde subito l'accesso a tutti i dati; nominare amministratori e titolari spetta al titolare, e ogni cambio resta nel registro modifiche." },
    ],
  },
  {
    id: "2026-10-30-menu",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "🧭", testo: "Barra laterale riordinata: Chat e Notifiche in alto per tutti; Gestione con anagrafiche e approvazioni; Registri, Pratiche e documenti e Configurazione sono sezioni a sé." },
    ],
  },
  {
    id: "2026-10-30-strumenti",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "🧰", testo: "Strumenti tecnici: 24 nuovi calcoli (sconti a cascata, margine e ricarico, pittura, bobine di cavo, giorni di registrazione TVCC…) e una ricerca per trovarli." },
      { icona: "✏️", testo: "Nei calcoli si possono scrivere i numeri con la virgola («8,5», «1.234,56»); corretti la posa del cavo, le scadenze D.F.F.M. e il 4 ottobre festivo dal 2026." },
    ],
  },
  {
    id: "2026-10-30-relazione",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "💶", testo: "Relazione della commessa: sintesi economica a colonne con ricavi, costi per voce (previsto e sostenuto), risultato e fatturazione." },
      { icona: "📋", testo: "«Copia testo» copia tutta la relazione, varianti comprese, e conferma «✓ Copiato»; la relazione indica anche la data dei sopralluoghi." },
    ],
  },
  {
    id: "2026-10-30-commenti",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "📷", testo: "Nei commenti di attività e sottoattività puoi allegare foto e file (PDF, Word, Excel…): restano legati al commento." },
      { icona: "✎", testo: "Un commento si può modificare da chi l'ha scritto: compare «✎ modificato» e lo storico mostra il testo di prima." },
      { icona: "🔢", testo: "«N. ordine» della commessa: il numero d'ordine dell'azienda, in prima colonna in Le mie commesse, Richiesta di fatturazione e Registro Commesse." },
    ],
  },
  {
    id: "2026-10-30-noleggi",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "🏗️", testo: "Noleggi: il noleggiatore si sceglie dall'Elenco Fornitori (prima quelli spuntati «Noleggiatore») e il costo comprende i trasporti di consegna e ritiro." },
      { icona: "📊", testo: "Registro noleggi → «Per fornitore»: resoconto di ogni noleggiatore per periodo e commessa, con il dettaglio dei noleggi in Excel o stampa." },
    ],
  },
  {
    id: "2026-10-30-indirizzi",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "📍", testo: "Indirizzo del cliente a pezzi: via, numero civico, CAP, comune e provincia. Il comune si sceglie dall'elenco e provincia e CAP si compilano da soli." },
      { icona: "⚠️", testo: "Se CAP e comune non corrispondono Nexiora lo segnala prima di salvare, e «📍 Controlla sulla mappa» mostra dove porta l'indirizzo." },
    ],
  },
  {
    id: "2026-10-30-rdo",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "📨", testo: "Richieste d'offerta ai fornitori: dalla NF «Richiedi offerte» a 2 o 3 fornitori, che le ricevono per email a nome dell'azienda; le risposte arrivano a chi le invia." },
      { icona: "⚖️", testo: "Nella scheda RdO registri le offerte (prezzi per riga, PDF), le confronti fianco a fianco e dall'offerta scelta nasce l'ODA già con i prezzi." },
    ],
  },
  {
    id: "2026-10-29-nf",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "📋", testo: "Richieste NF più chiare: stato sempre visibile (Da gestire, In gestione, Ordinata, Consegnata), descrizione con i suoi a capo, fornitore dall'elenco o N.D., offerta allegata dal computer." },
      { icona: "🔄", testo: "Scritto tutto nella descrizione? «Trasforma in articoli» divide le righe da solo, riconoscendo quantità e unità di misura." },
      { icona: "✉️", testo: "Ufficio acquisti: «Copia per richiesta d'offerta» da incollare nell'email al fornitore o in Excel, senza prezzi né dati interni." },
    ],
  },
  {
    id: "2026-10-29-le-mie-ore",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "⏱️", testo: "«Le mie ore» si attiva da sola per il personale Non operativo (ufficio, PM, direzione) con la scheda in Dipendenti collegata all'account: quelle ore vanno sempre nei costi delle commesse, al suo Costo/h." },
      { icona: "👤", testo: "In Dipendenti un avviso elenca gli account senza scheda: senza scheda le ore di quella persona non possono andare sui costi delle commesse." },
    ],
  },
  {
    id: "2026-10-24-formazione-calendario",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "🎓", testo: "Formazione su Nexiora, in video call o nella vostra sede: titolare e amministratori scelgono giorno e orario tra quelli liberi da La mia area → «Richiedi formazione». Durante la prova c'è un avvio gratuito di 45 minuti." },
    ],
  },
  {
    id: "2026-10-24",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "📅", testo: "Per i responsabili di commessa: in Home il programma lavori delle tue commesse, giorno per giorno, dalla Programmazione settimanale. La domenica sera arriva anche per email.", vai: { page: "home" } },
      { icona: "🗑️", testo: "Eliminare una commessa ora cancella anche tutti i suoi documenti, avvisando prima, e resta scritto nel Log Modifiche. Per confermare basta il nome o il codice." },
    ],
  },
  {
    id: "2026-10-23-timbrature",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "🕐", testo: "Timbrature dimenticate: la sera arriva un promemoria se manca l'uscita e, se l'azienda lo sceglie, aprendo Nexiora si mettono in regola i giorni mancanti inserendo gli orari o una giustificazione.", vai: { page: "presenze" }, etichetta: "Il mio cartellino" },
      { icona: "⚙️", testo: "Titolare e amministratori scelgono il livello in Impostazioni Aziendali → Presenze e approvazioni; le giustificazioni si decidono in cima ad Approvazione Cartellini." },
    ],
  },
  {
    id: "2026-10-23",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "⏱️", testo: "«Le mie ore»: uscendo con il tempo acceso resta una pillola piccola, da spostare dove vuoi, con pausa e stop. Con ✕ la nascondi e il conteggio continua.", vai: { page: "le-mie-ore" }, etichetta: "Apri Le mie ore" },
      { icona: "🔍", testo: "Materiali doppi: se lo stesso materiale è già in un ODA, una NF, una richiesta al magazzino o una voce a mano della commessa, Nexiora te lo chiede prima di inserirlo." },
      { icona: "📊", testo: "Cabina di Regia → Ore e personale: grafico delle ore della commessa settimana per settimana e ore per persona." },
      { icona: "📣", testo: "Segnalazioni cliente: scelto il cliente vedi le sue commesse; si gestiscono con «Prendi in carico», «Chiudi» con l'esito e «Riapri», e chi le ha registrate riceve un avviso.", vai: { page: "segnalazioni-cliente" }, etichetta: "Segnalazioni" },
      { icona: "📌", testo: "Note rosse «importanti»: in cima alle note e in Home, con un promemoria che si ripete (da ogni 30 minuti a ogni settimana), solo dalle 7 alle 19.", vai: { page: "registro-note" }, etichetta: "Le mie note" },
    ],
  },
  {
    id: "2026-10-22",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "⏱️", testo: "«Le mie ore»: a tutto schermo anche sul telefono, tocchi la commessa su cui lavori e il tempo parte; tocchi un'altra commessa e la prima si ferma da sola.", vai: { page: "le-mie-ore" }, etichetta: "Apri Le mie ore" },
      { icona: "💶", testo: "Le ore di «Le mie ore» diventano il costo delle commesse; il cartellino resta per presenze e paghe." },
      { icona: "↩️", testo: "Il tasto «indietro» del telefono chiude prima la finestra aperta, poi torna alla schermata precedente." },
    ],
  },
  {
    id: "2026-10-17",
    titolo: "Novità in Nexiora",
    voci: [
      { icona: "👀", testo: "In Home, «Da guardare adesso»: notifiche non lette, le tue attività più importanti con il motivo, cosa aspetta una tua risposta e i moduli non salvati.", vai: { page: "home" }, etichetta: "Vai alla Home" },
      { icona: "↩️", testo: "Se il telefono chiude Nexiora mentre fai altro, la ritrovi dove l'avevi lasciata: stessa pagina, commessa e scheda. Il tasto «indietro» torna alla schermata precedente." },
      { icona: "📝", testo: "Rapportini, sopralluoghi, manutenzioni, giornale, richieste, verbali e segnalazioni si salvano da soli sul telefono mentre li compili: se qualcosa va storto premi «Riprendi».", vai: { page: "le-mie-bozze" }, etichetta: "Le mie bozze" },
      { icona: "✍️", testo: "La mia firma: salvala una volta e mettila con un tocco come firma del tecnico in rapportini, manutenzioni e giornale.", vai: { page: "settings" }, etichetta: "Salvala ora" },
      { icona: "🔠", testo: "Sul telefono: testo più grande e vibrazione di conferma, in Impostazioni → Profilo → Questo dispositivo.", vai: { page: "settings" }, etichetta: "Impostazioni" },
      { icona: "🌙", testo: "Le firme si leggono sempre, anche con il tema scuro del telefono." },
    ],
  },
];

const CHIAVE = "nexiora_novita_vista";
export const ultimaNovita = () => NOVITA[0] || null;
export function novitaGiaVista(id) { try { return localStorage.getItem(CHIAVE) === id; } catch { return true; } }
export function segnaNovitaVista(id) { try { localStorage.setItem(CHIAVE, id); } catch { /* */ } }
